module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_492016.eb895696.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetInRecargas/FormatoSimplificado_492016.pdf
// module id = 886
// module chunks = 0